module.exports = __webpack_public_path__ + "img/ladder_not_open.0cdfbe4e.png";